<template>
    <div class="flex items-center flex-no-shrink text-white mr-6">
        <img src="./../assets/lkLogo.jpg" alt="Dasos Logo" class="block h-12 mr-2" >
        <span class="font-bold text-3xl font-sans">广州康莱药业有限公司</span>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>